/**
 * Budget Allocation Controller
 *
 * @package:  frictionlessdigital/dashboard
 * @version:  2.7
 * @return:   Controller
 */

import angular from 'angular';

angular.module('flsControllers').controller('ProgramMonthlyCostsController', [
    '$scope',
    'ProgramMonthlyCosts',
    function($scope, ProgramMonthlyCosts){

    /**
     * Loading state
     *
     * @type {Boolean}
     */
    $scope.loading = false;

    /**
     * Define starting data
     *
     * @type {Object}
     */
    $scope.data = {
        groups:[],
        programs:[],
    }

    /**
     * Init the Controller with the Context Ref string
     *
     * @param  {string} context_ref
     * @return {void}
     */
    $scope.init = function(brand, from = null, to = null) {
        this.load({
            brand: brand || $scope.$parent.brand,
            from : from || $scope.$parent.from,
            to   : to || $scope.$parent.to,
        });
    }

    /**
     * Load the data
     *
     * @param  {object} query
     * @return void
     */
    $scope.load = function(query) {
        /* Enable loader */
        $scope.loading = true;
        /* fetch data */
        ProgramMonthlyCosts
            .get(query)
            .$promise
            .then(function(response, headers){
                /* Replace the data*/
                $scope.data = response.data;
                /* Disable loader */
                $scope.loading = false;
            }, function(response, headers){
                _.each(response.data, function(error){
                    $.publish('resource.error', error);
                });
            });
    }

    /**
     * Access programs as method
     *
     * @param  string | null    month
     * @return collection
     */
    $scope.programs = function(month = null) {
        /* Chain the values */
        return _.chain(this.data.programs)
                /* filter by group value, must be exact match */
                .filter((program)=>{
                    return _.isNull(month) || _.isEqual(program.month, month);
                })
                .value();
    }

    /**
     * Get the optimistic values
     *
     * @param  {string | null} month
     * @return {collection}
     */
    $scope.optimistic = function(month = null) {
        /* collect programs */
        var collection = this.programs(month);
        /* apply filter */
        return _.filter(collection, ['is_cancelled', false]);
    }

    /**
     * Get the optimistic values
     *
     * @param  {string | null} month
     * @return {collection}
     */
    $scope.pessimistic = function(month = null) {
        /* collect programs */
        var collection = this.programs(month);
        /* apply filter */
        return _.filter(collection, ['is_cancelled', true]);
    }

    /**
     * Sum the cost produced by the resource
     *
     * @param  {collection} collection
     * @return {float}
     */
    $scope.costs = function(collection) {
        return _.sumBy(collection, 'cost');
    }

    /**
     * Calculate the average
     *
     * @param  {string | null} month
     * @return {float}
     */
    $scope.average = function(month = null) {
        /* collect programs */
        let optimistic = this.optimistic(month);
        /* Mean by */
        let mean = _.meanBy(optimistic, 'cost');
        /* return */
        return _.isNaN(mean) ? '' : mean;
    }

    /**
     * Calculate the median
     *
     * @param  {string | null} month
     * @return {float}
     */
    $scope.median = function(month = null) {
        /* collect programs */
        let optimistic = this.optimistic(month);
        /* sortBy and pluck costs */
        let costs = _.chain(optimistic)
                     .sortBy('cost')
                     .map('cost')
                     .value();
        /* set the defaults */
        let numsLen = costs.length;
        /* Sanity check */
        if (numsLen > 1) {
            /* if even */
            if (numsLen % 2 === 0 ) {
                /* average of two middle numbers */
                return _.mean([costs[numsLen / 2 - 1], costs[numsLen / 2]]);
            }
            /* middle number */
            return costs[(numsLen - 1) / 2]
        };
        /* Final sanity */
        return _.head(costs) || 0;
    }
}]);
